export class UserCredentials {
    Id_Session: string = null;
    Id_User: number = null;
    Id_Tarif: number = null;
    EMail: string = null;
    Region: string = null;
    Sex: boolean = null;
    TarifName: string = null;
    PaymentActiveDue: string = null;
    Vallet: string = null;
    ExternalSystem: string = null;
    SsoAuth: string = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-credentials-model.ts